import { Box, Button, Card, Stack, Typography } from "@mui/material";
import BookingDetailsCard from "./BookingDetailsCard";
import { useState } from "react";

const GroupedBookingCardDetails = ({ bookings, index }) => {
    const [expanded, setExpanded] = useState(false);

    if (!expanded) {
        return (
            <Box
                sx={{
                    position: "relative",
                    minHeight: 240, 
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    paddingTop: 3,
                    // Interactive hover mechanics
                    "&:hover .back-card": {
                        transform: "translateY(-14px) rotate(-5deg)",
                    },
                    "&:hover .middle-card": {
                        transform: "translateY(-7px) rotate(4deg)",
                    },
                    "&:hover .front-card": {
                        transform: "scale(1.015)",
                    }
                }}
                onClick={() => setExpanded(true)}
            >
                {/* Back card */}
                <Card
                    className="back-card"
                    elevation={1}
                    sx={{
                        position: "absolute",
                        top: 12,
                        width: "92%",
                        height: 180, 
                        opacity: 0.4,
                        zIndex: 1,
                        borderRadius: 3, // Updated border radius
                        transform: "rotate(-2.5deg)",
                        transformOrigin: "bottom center",
                        transition: "transform 0.3s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.3s ease",
                        backgroundColor: "background.paper",
                        border: "1px solid",
                        borderColor: "divider",
                    }}
                />

                {/* Middle card */}
                <Card
                    className="middle-card"
                    elevation={2}
                    sx={{
                        position: "absolute",
                        top: 6,
                        width: "96%",
                        height: 180,
                        opacity: 0.7,
                        zIndex: 2,
                        borderRadius: 3, // Updated border radius
                        transform: "rotate(2deg)",
                        transformOrigin: "bottom center",
                        transition: "transform 0.3s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.3s ease",
                        backgroundColor: "background.paper",
                        border: "1px solid",
                        borderColor: "divider",
                    }}
                />

                {/* Front card */}
                <Box 
                    className="front-card"
                    sx={{ 
                        position: "relative", 
                        width: "100%", 
                        zIndex: 3,
                        transition: "transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)",
                        "& > div": { borderRadius: 3 } // Enforces radius on child BookingDetailsCard if not built-in
                    }}
                >
                    <BookingDetailsCard
                        booking={bookings[0]}
                        index={index}
                    />

                    <Box
                        sx={{
                            p: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        {/* Generic Count Label */}
                        <Typography variant="body2" sx={{ fontWeight: 600, color: "text.secondary" }}>
                            {bookings.length} Items
                        </Typography>

                        {/* Cleaner text indicator instead of a generic button */}
                        <Typography 
                            variant="button" 
                            sx={{ 
                                fontSize: "0.75rem", 
                                fontWeight: 500, 
                                color: "primary.main",
                                letterSpacing: "0.5px",
                                textTransform: "none",
                            }}
                        >
                            View all ↓
                        </Typography>
                    </Box>
                </Box>
            </Box>
        );
    }

    return (
        <Stack spacing={2}>
            {bookings.map((booking, i) => (
                <Box key={booking.id} sx={{ "& > div": { borderRadius: 3 } }}>
                    <BookingDetailsCard
                        booking={booking}
                        index={index}
                    />
                </Box>
            ))}

            <Button
                size="small"
                variant="text"
                onClick={(e) => {
                    e.stopPropagation(); 
                    setExpanded(false);
                }}
                sx={{ 
                    alignSelf: "center", 
                    textTransform: "none",
                    mt: 1, 
                    borderRadius: 2,
                    px: 3 
                }}
            >
                Show less
            </Button>
        </Stack>
    );
};

export default GroupedBookingCardDetails;